export default __webpack_public_path__ + "static/media/cifarLogo.c071c656.jpg";